import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { RouterModule } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ToastService } from "../../../../shared/services/toast.service";
import { ICourseModule } from "../../../../courseModule/models/courseModule.model";
import { ILesson } from "../../../../lesson/models/lesson.model";
import { Store } from "@ngrx/store";
import { getCourseModulesSelector } from "../../../store/course.selectors";
import { LessonService } from "../../../../lesson/services/lesson.service";
import { getCourse } from "../../../store/course.actions";

@Component({
    selector: 'clp-course-module-lesson-list',
    styleUrls: ['./courseLessonList.component.scss'],
    templateUrl: './courseLessonList.component.html',
    imports: [
        RouterModule,
        TranslateModule,
        CommonModule
    ],
    providers: [
        ToastrService,
        LessonService
    ]
})
export class CourseModuleLessonListComponent implements OnInit {
    @Input() courseId!:string | null;
    @Output() lessonEditEvent: EventEmitter<ILesson> = new EventEmitter<ILesson>();

    private store = inject(Store);
    private toastService = inject(ToastService);
    private translate = inject(TranslateService);
    private lessonService = inject(LessonService);

    courseModules$!: Observable<ICourseModule[]>;
    openModuleIndex: number | null = null;

    ngOnInit(): void {
      this.loadLessons();
    }

    loadLessons(): void {
      if (this.courseId !== undefined && this.courseId !== null) {
        this.courseModules$ = this.store.select(getCourseModulesSelector);
      }
    }

    toggleModule(index: number): void {
      this.openModuleIndex = this.openModuleIndex === index ? null : index;
    }

    editLesson(lesson: ILesson) {
        if (lesson === undefined || lesson === null)
            return;
        this.lessonEditEvent.emit(lesson);
    }

    deleteLesson(id: string | undefined) {
        if (id === undefined || id === null)
            return;

        var return$ = this.lessonService.deleteLesson(id);

        return$.subscribe(lesson => {
            if (lesson !== undefined && lesson !== null && lesson.id !== null) {
                this.toastService.show(this.translate.instant("lesson.delete.successMessage"), "");
                if (this.courseId !== undefined && this.courseId !== null) {
                    this.store.dispatch(getCourse(this.courseId));
                }
            }
        });
    }
}
